<template>
   <portal to="modal">
      <span v-if="data" ref="sticky_button" :class="{ 'hide': !show }" class="sticky-button"
         @click="onClick">
         <svg class="errow" id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg"
            width="11.352" height="11.351" viewBox="0 0 11.352 11.351">
            <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
               d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
               fill="#fff"></path>
         </svg>
         <span class="bold uppercase f-14 f-white">{{ _.get(data, "title") }}</span>
         <div class="desktop-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="31.839" height="27.949" viewBox="0 0 31.839 27.949">
               <path id="Union_56" data-name="Union 56"
                  d="M-195.538,2920.427A6.435,6.435,0,0,1-189.11,2914a6.256,6.256,0,0,1,1.069.091,5.887,5.887,0,0,1,1.016.257,1.4,1.4,0,0,1,.9,1.006l1.913,8.335a1.4,1.4,0,0,1-.354,1.28c-.192.2-.2.2-1.929,1.111a13.872,13.872,0,0,0,6.82,6.825c.908-1.736.913-1.74,1.112-1.931a1.4,1.4,0,0,1,1.28-.354l8.335,1.914a1.394,1.394,0,0,1,1.006.9,5.965,5.965,0,0,1,.258,1.021,6.4,6.4,0,0,1,.089,1.065,6.435,6.435,0,0,1-6.427,6.428A21.546,21.546,0,0,1-195.538,2920.427Zm25.935,4.277a1.036,1.036,0,0,1,0-1.464l2.372-2.372h-11.981a1.034,1.034,0,0,1-1.034-1.034,1.033,1.033,0,0,1,1.034-1.034h11.981l-2.372-2.373a1.036,1.036,0,0,1,0-1.464,1.036,1.036,0,0,1,1.464,0L-164,2919.1a1.036,1.036,0,0,1,0,1.464v0l-4.136,4.136a1.032,1.032,0,0,1-.732.3A1.032,1.032,0,0,1-169.6,2924.7Z"
                  transform="translate(195.538 -2914)" fill="#7063e9" />
            </svg>
         </div>
      </span>

   </portal>
</template>   
 
<script>
export default {
   props: ["contentData"],
   data() {
      return {
         show: false,
         scroll_count: 0
      }
   },
   mounted() {
      this.onscroll();
   },
   beforeDestroy() {
      console.log('before destroy')
      this.removeScrollListener();
   },
   computed: {
      data() {
         return _.get(this.contentData, "data.list.0.buttons.0")
      },
      smooth_scroll() {
         return this.$store.state.main.smooth_scroll;
      }
   },
   methods: {
      onClick() {
         if (_.get(this.data, 'url')) {
            window.open(_.get(this.data, 'url'), _.get(this.data, 'targetblank') ? '_blank' : '_self');
         } else {
            this.$store.commit('main/setState', { key: 'price_modal', val: true })
            this.$store.state.main.mails_taxonomy = _.get(this.contentData, 'data.list.0.mails')  || false;
            this.$store.state.main.set_price_title = _.get(this.contentData, 'data.list.0.link_name') || '';
         }
      },
      onscroll() {
         if (window.innerWidth >= 1024) {
            this.smooth_scroll.on('scroll', this.show_hide);
         } else {
            document.addEventListener('scroll', this.show_hide);
         }
      },
      show_hide() {

         if (window.innerWidth >= 1024 && this.scroll_count < 3) {
            this.scroll_count = this.scroll_count + 1;
         } else {
            this.scroll_count = 2;
         }

         const divRect = this.$refs.sticky_button.getBoundingClientRect().bottom;
         const footerRect = document.querySelector('footer').getBoundingClientRect().top;
         if (footerRect < divRect) {
            this.show = false
         } else {
            this.scroll_count === 2 ? this.show = true : ''
         }
      },
      removeScrollListener() {
         if (window.innerWidth >= 1024) {
            this.smooth_scroll.off("scroll", this.show_hide);
         } else {
            document.removeEventListener("scroll", this.show_hide);
         }
      },
   }
}
</script>

<style lang="scss" scoped>
.sticky-button {
   position: fixed;
   width: 240px;
   height: 62px;
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 99;
   cursor: pointer;
   transition: .6s;
   bottom: 60px;
   right: 47px;
   border-radius: 6px;
   background: #7063e9;
   padding: 16px 72px 16px 16px;
   transition: .4s;

   &:hover{
      background: #613dd1;
   }

   .errow {
      flex: none;
      display: none;
   }

   .desktop-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 4px;
      width: 52px;
      height: 52px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      transition: .4s;
   }
   .desktop-icon path{
      transition: 0.4s;
   }
   &:hover .desktop-icon path{
      fill: #613dd1;
   }

   span {
      color: #fff;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      transition: .4s;
   }

   &.hide {
      opacity: 0;
      pointer-events: none;
   }
}

@media (max-width: 1023px) {
   .sticky-button {
      right: 45px;
   }
}

@media (max-width: 767px) {
   .sticky-button {
      right: 20px;
      width: calc(100% - 40px);
      bottom: 20px;
      padding-right: 16px;

      .desktop-icon {
         display: none;
      }
   }

}
</style>